// Auto-detect API URL: use env var in development, or current origin in production
const API_URL = process.env.REACT_APP_BACKEND_URL || window.location.origin;

export default API_URL;
